import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [insightsDropdown, setInsightsDropdown] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-6'}`} data-id="element-184">
      <div className="container mx-auto px-4 md:px-8" data-id="element-185">
        <div className="flex justify-between items-center" data-id="element-186">
          <div data-id="element-187">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5oM7arK9DtXwRMGoaJxhCF/Copy_of_Niqqanno_logo_%281%29.png" alt="Niqqanno Consulting Logo" className="h-20 w-auto" data-id="element-188" />
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-189">
            <a href="#about" className={`font-medium text-lg ${isScrolled ? 'text-primary' : 'text-white'} hover:text-gold transition-colors duration-300`} data-id="element-190">
              About
            </a>
            <div className="relative group" data-id="element-191">
              <button className={`flex items-center font-medium text-lg ${isScrolled ? 'text-primary' : 'text-white'} hover:text-gold transition-colors duration-300`} onClick={() => setServicesDropdown(!servicesDropdown)} data-id="element-192">
                Services <ChevronDown size={16} className="ml-1" data-id="element-193" />
              </button>
              <div className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-md overflow-hidden transform scale-0 group-hover:scale-100 transition-transform duration-200 origin-top" data-id="element-194">
                <a href="#corporate-law" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white" data-id="element-195">
                  Corporate Law
                </a>
                <a href="#business-strategy" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white" data-id="element-196">
                  Business Strategy
                </a>
              </div>
            </div>
            <div className="relative group" data-id="element-197">
              <button className={`flex items-center font-medium text-lg ${isScrolled ? 'text-primary' : 'text-white'} hover:text-gold transition-colors duration-300`} onClick={() => setInsightsDropdown(!insightsDropdown)} data-id="element-198">
                Insights <ChevronDown size={16} className="ml-1" data-id="element-199" />
              </button>
              <div className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-md overflow-hidden transform scale-0 group-hover:scale-100 transition-transform duration-200 origin-top" data-id="element-200">
                <a href="#case-studies" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white" data-id="element-201">
                  Case Studies
                </a>
                <a href="#articles" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white" data-id="element-202">
                  Articles
                </a>
              </div>
            </div>
            <a href="#contact" className={`font-medium text-lg ${isScrolled ? 'text-primary' : 'text-white'} hover:text-gold transition-colors duration-300`} data-id="element-203">
              Contact
            </a>
            <a href="mailto:niqqannoconsult21@gmail.com?subject=Consultation%20Request&body=I'm%20interested%20in%20booking%20a%20consultation%20with%20Niqqanno%20Consulting." className="bg-gold text-primary-dark px-4 py-1.5 rounded font-medium hover:bg-gold-light transition-colors duration-300" data-id="element-204">
              Book Consultation
            </a>
          </nav>
          {/* Mobile Menu Button */}
          <button className={`md:hidden ${isScrolled ? 'text-primary' : 'text-white'}`} onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-205">
            {isMenuOpen ? <X size={24} data-id="element-206" /> : <Menu size={24} data-id="element-207" />}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white absolute top-full left-0 w-full shadow-md" data-id="element-208">
          <div className="container mx-auto px-4 py-4" data-id="element-209">
            <div className="flex flex-col space-y-4" data-id="element-210">
              <a href="#about" className="text-primary text-lg font-medium hover:text-gold transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-211">
                About
              </a>
              <div data-id="element-212">
                <button className="flex items-center justify-between w-full text-primary text-lg font-medium" onClick={() => setServicesDropdown(!servicesDropdown)} data-id="element-213">
                  Services{' '}
                  <ChevronDown size={16} className={`transition-transform duration-200 ${servicesDropdown ? 'transform rotate-180' : ''}`} data-id="element-214" />
                </button>
                {servicesDropdown && <div className="mt-2 ml-4 flex flex-col space-y-2" data-id="element-215">
                    <a href="#corporate-law" className="text-primary hover:text-gold transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-216">
                      Corporate Law
                    </a>
                    <a href="#business-strategy" className="text-primary hover:text-gold transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-217">
                      Business Strategy
                    </a>
                  </div>}
              </div>
              <div data-id="element-218">
                <button className="flex items-center justify-between w-full text-primary text-lg font-medium" onClick={() => setInsightsDropdown(!insightsDropdown)} data-id="element-219">
                  Insights{' '}
                  <ChevronDown size={16} className={`transition-transform duration-200 ${insightsDropdown ? 'transform rotate-180' : ''}`} data-id="element-220" />
                </button>
                {insightsDropdown && <div className="mt-2 ml-4 flex flex-col space-y-2" data-id="element-221">
                    <a href="#case-studies" className="text-primary hover:text-gold transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-222">
                      Case Studies
                    </a>
                    <a href="#articles" className="text-primary hover:text-gold transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-223">
                      Articles
                    </a>
                  </div>}
              </div>
              <a href="#contact" className="text-primary text-lg font-medium hover:text-gold transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-224">
                Contact
              </a>
              <a href="mailto:niqqannoconsult21@gmail.com?subject=Consultation%20Request&body=I'm%20interested%20in%20booking%20a%20consultation%20with%20Niqqanno%20Consulting." className="bg-gold text-primary-dark px-4 py-2 rounded text-center font-medium hover:bg-gold-light transition-colors duration-300" onClick={() => setIsMenuOpen(false)} data-id="element-225">
                Book Consultation
              </a>
            </div>
          </div>
        </div>}
    </header>;
};